import React from "react";

const TestPage = () => {
  return (
    <div style={{ padding: "100px 20px", textAlign: "center" }}>
      <h1>Test Page Working!</h1>
      <p>If you can see this, routing is working correctly.</p>
      <a href="/" style={{ color: "blue" }}>Go back to Home</a>
    </div>
  );
};

export default TestPage;
